import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgLottolandLLogo = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.832 20.238c-.2 0-.339-.182-.298-.384l3.428-16.528a.32.32 0 0 1 .299-.242h3.986c.2 0 .339.182.299.384l-2.532 12.23c-.04.201.1.383.299.383h6.855c.2 0 .34.181.3.384l-.738 3.551a.32.32 0 0 1-.299.242H9.833v-.02M30.732 22.498c-4.804 1.514-9.745 2.443-14.728 2.443-4.982 0-9.944-.928-14.727-2.443-.32-.1-.578.242-.34.505 2.89 2.926 6.816 4.742 10.842 5.509a23 23 0 0 0 4.225.404c1.416 0 2.83-.142 4.225-.404 4.026-.788 7.932-2.583 10.842-5.51.22-.262-.02-.604-.34-.504"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgLottolandLLogo;
